/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComputedSource } from '../../models/computed-source';
import { TagComputedUpdate } from '../../models/tag-computed-update';

export interface UpdateTagComputed$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * the computed tag source type
 */
  source?: ComputedSource;
      body: TagComputedUpdate
}

export function updateTagComputed(http: HttpClient, rootUrl: string, params: UpdateTagComputed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateTagComputed.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('source', params.source, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateTagComputed.PATH = '/tags-computed/{uid}';
